module.exports = __webpack_public_path__ + "img/ipoh.aadf23fe.png";